/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import DS from 'ember-data';
import BackfillModel from 'cio/models/backfill';
import { isNone } from '@ember/utils';
import { ModelRegistry } from 'ember-data/model';

interface BackfillObjectArgs {
  backfill: BackfillModel;
  showLinks: boolean;
}

export default class BackfillObject extends Component<BackfillObjectArgs> {
  @service store!: DS.Store;

  @tracked object?: ModelRegistry[keyof ModelRegistry] | null | { name: string; loading: boolean };

  fetchObject = task(async () => {
    let { objectType } = this.args.backfill.info;
    let { objectId } = this.args.backfill;

    if (isNone(objectId) || isNone(objectType)) {
      return;
    }

    this.object = { name: '…', loading: true };

    if (objectType === 'broadcast-trigger') {
      let { objectVersion } = this.args.backfill;
      objectId = `${objectId}-${objectVersion}`;
    }

    let object: BackfillObject['object'] = this.store.peekRecord(objectType, objectId);

    if (isNone(object)) {
      try {
        object = await this.store.findRecord(objectType, objectId);
      } catch (e) {
        object = { name: `${objectId}`, loading: false };
      }
    }

    this.object = object;
  });
}
